import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgDrops = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 18.0417V14.2917"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.125 16.1667H13.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.625 14.9167C17.625 16.4085 17.0324 17.8392 15.9775 18.8941C14.9226 19.949 13.4918 20.5417 12 20.5417C10.5082 20.5417 9.07742 19.949 8.02252 18.8941C6.96763 17.8392 6.375 16.4085 6.375 14.9167C6.375 12.4683 9.84333 7.28998 11.3233 5.24998C11.3979 5.14722 11.4958 5.06357 11.6089 5.0059C11.722 4.94822 11.8472 4.91815 11.9742 4.91815C12.1011 4.91815 12.2263 4.94822 12.3394 5.0059C12.4526 5.06357 12.5504 5.14722 12.625 5.24998C14.1058 7.28998 17.625 12.4683 17.625 14.9167Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.375 14.9167C6.375 13.1208 8.24083 9.85583 9.82 7.4375C9.00833 6.045 8.07 4.70166 7.50583 3.92416C7.44776 3.84445 7.37167 3.77959 7.28376 3.73487C7.19586 3.69015 7.09863 3.66684 7 3.66684C6.90137 3.66684 6.80414 3.69015 6.71624 3.73487C6.62833 3.77959 6.55224 3.84445 6.49417 3.92416C5.3425 5.5125 2.625 9.46166 2.625 11.3658C2.62624 12.4266 3.01278 13.4508 3.7127 14.248C4.41262 15.0451 5.37827 15.5608 6.43 15.6992C6.39373 15.4399 6.37535 15.1784 6.375 14.9167V14.9167Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5059 3.92416C17.4478 3.84445 17.3717 3.77959 17.2838 3.73487C17.1959 3.69015 17.0987 3.66684 17.0001 3.66684C16.9014 3.66684 16.8042 3.69015 16.7163 3.73487C16.6284 3.77959 16.5523 3.84445 16.4942 3.92416C15.9259 4.70833 14.9759 6.06666 14.1609 7.47166C15.7492 9.88833 17.6259 13.1283 17.6259 14.9167C17.6257 15.1798 17.6073 15.4427 17.5709 15.7033C18.6226 15.5649 19.5883 15.0492 20.2882 14.2521C20.9881 13.455 21.3746 12.4308 21.3759 11.37C21.3751 9.46166 18.6576 5.5125 17.5059 3.92416Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgDrops.displayName = 'SvgDrops';
export default SvgDrops;
